var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_9382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.32422 24.6641C3.61719 24.6641 3.92188 24.5586 4.29688 24.3477L10.2617 21.1367L16.7422 24.7695C17.1641 25.0039 17.6211 25.1211 18.0547 25.1211C18.4648 25.1211 18.875 25.0156 19.2266 24.8164L25.3555 21.3359C26.0586 20.9492 26.375 20.3867 26.375 19.6016V3.81641C26.375 2.94922 25.8945 2.46875 25.0508 2.46875C24.7578 2.46875 24.4531 2.5625 24.0664 2.77344L17.8555 6.23047L11.4922 2.32812C11.1289 2.11719 10.7188 2 10.3086 2C9.88672 2 9.46484 2.11719 9.10156 2.32812L3.00781 5.79688C2.31641 6.19531 2 6.75781 2 7.54297V23.3047C2 24.1719 2.48047 24.6641 3.32422 24.6641ZM9.5 19.2734L4.21484 22.1797C4.15625 22.2031 4.09766 22.2383 4.03906 22.2383C3.94531 22.2383 3.88672 22.168 3.88672 22.0508V8C3.88672 7.71875 3.99219 7.51953 4.27344 7.35547L9.07812 4.54297C9.23047 4.46094 9.35938 4.39062 9.5 4.30859V19.2734ZM11.3867 19.4609V4.55469C11.5039 4.625 11.6445 4.69531 11.7617 4.76562L16.9883 7.95312V22.6016C16.8242 22.5078 16.6484 22.4258 16.4727 22.332L11.3867 19.4609ZM18.875 22.8125V7.83594L24.1602 4.95312C24.2188 4.91797 24.2773 4.89453 24.3242 4.89453C24.4297 4.89453 24.4883 4.96484 24.4883 5.08203V19.1328C24.4883 19.4258 24.3711 19.625 24.1016 19.7891L19.4023 22.5195C19.2266 22.625 19.0508 22.7305 18.875 22.8125Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_9382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.375,
    height: 23.1211,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.d0df933b96e81f12efc96988a6d8a09e.svg";
export { ForwardRef as ReactComponent };